// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__XkTAX","content":"styles_content__1gyBq","selectAll":"styles_selectAll__2Kbjc"};